/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Description_DescInputs */

const en_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export AD with synthetic voice`)
};

const fr_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter l'AD avec une voix synthetique`)
};

const de_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren Sie AD mit synthetischer Stimme`)
};

const it_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione di annunci con voce sintetica`)
};

const ru_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт рекламы с синтезированным голосом`)
};

const es_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar AD con voz sintética`)
};

const zh_cn2_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带有合成语音的广告`)
};

const ja_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合成音声で広告をエクスポート`)
};

const hi_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृत्रिम आवाज के साथ विज्ञापन निर्यात करें`)
};

const pt_pt2_file_export_audio_description_desc = /** @type {(inputs: File_Export_Audio_Description_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar anúncio com voz sintética`)
};

/**
* | output |
* | --- |
* | "Export AD with synthetic voice" |
*
* @param {File_Export_Audio_Description_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_description_desc = /** @type {((inputs?: File_Export_Audio_Description_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Description_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_description_desc(inputs)
	if (locale === "de") return de_file_export_audio_description_desc(inputs)
	if (locale === "it") return it_file_export_audio_description_desc(inputs)
	if (locale === "ru") return ru_file_export_audio_description_desc(inputs)
	if (locale === "es") return es_file_export_audio_description_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_description_desc(inputs)
	if (locale === "ja") return ja_file_export_audio_description_desc(inputs)
	if (locale === "hi") return hi_file_export_audio_description_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_description_desc(inputs)
	return en_file_export_audio_description_desc(inputs)
});